import React from "react";
import { FaCalendarPlus } from "react-icons/fa";
import "./RenewButton.css";

// Renewing used to be an unlabelled calendar icon whose only label was a hover
// tooltip — which does not exist on touch, and which put it on the same visual
// footing as "view machines" right next to it. It is a named button now.
//
// Shared by every licenses table so the action looks and reads the same
// wherever a license is listed; it appeared in two tables already and was
// drifting apart in exactly the way the quote form did.

// Expired, or expiring within 3 days. Same threshold the Status pill uses, so
// a row showing "Expiring Soon" always shows the loud button and vice versa.
export const needsRenewalSoon = (expiresAt) => {
  if (!expiresAt) return false;
  const days = Math.ceil((new Date(expiresAt) - new Date()) / (1000 * 60 * 60 * 24));
  return days <= 3;
};

export default function RenewButton({ expiresAt, onClick, label = "Renew", urgent }) {
  // `urgent` is an override for callers that already know (the bulk bar);
  // otherwise it follows the license's own expiry.
  const isUrgent = urgent !== undefined ? urgent : needsRenewalSoon(expiresAt);

  return (
    <button
      type="button"
      className={`renew-btn${isUrgent ? " is-urgent" : ""}`}
      onClick={onClick}
    >
      <FaCalendarPlus size={11} /> {label}
    </button>
  );
}
